var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1874 9.55745V12.0435L10.223 12.2828C8.12709 12.4519 6.41739 14.03 6.08124 16.1058C6.00819 16.5569 5.94174 17.0088 5.88193 17.4614C5.85225 17.686 5.972 17.9034 6.17675 18.0003L6.31159 18.0642C15.8118 22.5624 27.1879 22.5624 36.6882 18.0642L36.8231 18.0003C37.0278 17.9034 37.1475 17.686 37.1178 17.4614C37.0581 17.0088 36.9916 16.5569 36.9186 16.1058C36.5825 14.03 34.8727 12.4519 32.7767 12.2828L29.8124 12.0435V9.55745C29.8124 8.04151 28.7034 6.7537 27.2042 6.52883L25.0694 6.2086C22.703 5.85364 20.2968 5.85364 17.9305 6.2086L15.7956 6.52883C14.2965 6.7537 13.1874 8.04151 13.1874 9.55745ZM24.68 8.80456C22.5718 8.48832 20.428 8.48832 18.3198 8.80456L16.185 9.12478C15.9708 9.15691 15.8124 9.34089 15.8124 9.55745V11.8587C19.601 11.6417 23.3988 11.6417 27.1874 11.8587V9.55745C27.1874 9.34089 27.029 9.15691 26.8148 9.12478L24.68 8.80456Z",
    fill: "#F77E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4569 21.1237C37.4438 20.8785 37.1873 20.7252 36.9627 20.8246C27.2135 25.1413 15.7862 25.1413 6.03713 20.8246C5.8126 20.7252 5.55591 20.8785 5.54286 21.1237C5.36474 24.4687 5.54422 27.828 6.08124 31.1442C6.4174 33.2199 8.1271 34.798 10.223 34.9673L13.4989 35.2317C18.8242 35.6615 24.1755 35.6615 29.5009 35.2317L32.7767 34.9673C34.8727 34.798 36.5825 33.2199 36.9186 31.1442C37.4555 27.828 37.6351 24.4687 37.4569 21.1237Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.3906c6ab9ab0f56956d65e2aae01cb08.svg";
export { ForwardRef as ReactComponent };